<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h1">FOREWORD</p>
<p class="normal">This is a book I had to write. George Weidenfeld, my British publisher and friend, believed it should be published, and read as well. I thank him affectionately for his unfailing confidence.</p>
<p class="indent">Dov Sion, my husband, objects to and abhors any self-induced exposure. With gentleness and understanding, he deviated from this principle and gave me his full support during the long and often painful writing of this book. David Rieff, senior editor at Farrar, Straus and Giroux, was my first objective reader. I am indebted to him not only for editing the manuscript for publication but for easing my anxieties and enabling me to work with the right perspective on the final version.</p>
<p class="indent">My friends Shimshon Arad, Kay Cohen, Bess Simon, Betty Epstein, Marianne Griessman, and Ira Bermak were kind enough to read the book in manuscript form. For their comments, encouragement, and support, I am profoundly grateful.</p>
<p class="indent">I must mention with thanks Pamela Levy, who managed the impossible and turned the undecipherable handwritten manuscript, with attention and care, into a typed readable one.</p>
<p class="indent-1">My mother’s contribution to this book was invaluable. She made available to me her amazing memory and the hundreds of letters my father wrote her. She let me touch exposed sensitive nerve ends and bravely removed protective fences in order to help me learn and understand.</p>
<p class="indent">My brothers’ role in my life and my father’s is reduced to a minimum in this book. That does not reflect reality but their wish, which I wholeheartedly respect. They may want to tell their own stories one day, and it should be their prerogative when and how to do it.</p>
<p class="indent">My father wrote me when I was working on my first book: “As you are writing a book, you should put all your efforts into making it a good one, and when I say ‘good,’ I mean ‘honest.’ I see no harm in full exposure of inner statements, providing you don’t compromise on honesty.” It comforts me to think that, were he alive and read this book, he would have been satisfied that no such compromise was made.</p>
<p class="right">Y.D.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// franmatter01.vue?27667224